import React from 'react'
import {Switcher} from '@components/common/base/switcher'

export interface SwitcherProps {
  active: boolean
  disabled?: boolean
  onClick?: (e: React.MouseEvent) => void
  className?: string
  title?: string
}

export const SharedSwitcher = (props: SwitcherProps) => {
  return <Switcher {...props} />
}
